// extracted by mini-css-extract-plugin
export default {"results--text":"ActionsRow_results--text__MuShR font-xs-regular","content--icon":"ActionsRow_content--icon__PXcoz"};